import React from 'react';
import { useCampoFormularioProps } from 'service/restricao/useCampoFormularioProps/useCampoFormularioProps';

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}


export const Label: React.FunctionComponent<LabelProps> = (props) => {
  const restricoesProps = useCampoFormularioProps(props.htmlFor ?? 'htmlFornameNãoDefinido!');

  if (restricoesProps.hidden)
    return <></>
  
  return <label {...props} />
}
